<template>
  <div class="fl yx_zixunbox">
    <h3 class="yx_zixuntit">{{title}}</h3>
    <ul class="yx_zixunlist" :class="cow === 5 ? 'yxempty_zixunlist' : ''">
      <i></i>
      <li class="clearfix" v-if="zixunList.length !== 0" v-for="(item, index) in zixunList" :key="index">
        <a :href="item.url">
          <div class="fl yx_zixunimg" :style="`background: url(${item.litpic}) center`"></div>
          <div class="fl yx_zixunword">
            <p :title="item.title">{{item.title}}</p>
            <p :title="item.description">{{item.description}}</p>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import {getArticle} from 'js/getArticle.js'
export default {
  name: 'Zixun',
  props: ['typeids', 'title', 'cow'],
  data () {
    return {
      zixunList: []
    }
  },
  computed: {
    getCow () {
      return this.cow
    }
  },
  watch: {
    getCow (newVal) {
      let _this = this
      getArticle(this.typeids, newVal, '_WWW', 1).then(function (response) {
        _this.$nextTick(() => {
          _this.zixunList = response
        })
      })
    }
  },
  created () {
    let _this = this
    getArticle(this.typeids, this.cow, '_WWW', 1).then(function (response) {
      _this.$nextTick(() => {
        _this.zixunList = response
      })
    })
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.fl
  float: left
.yx_zixunbox
  width: 254px
  min-height: 380px
  margin-top: 14px
  margin-left: 12px
  .yx_zixuntit
    width: 93%
    height: 20px
    line-height: 20px
    font-size: 18px
    color: #333333
    padding-left: 9px
    border-left: 3px solid $articleIcon
  .yx_zixunlist
    width: 95%
    margin-top: -4px
    margin-left: -5px
    padding-left: 17px
    position: relative
    i
      display: block
      width: 10px
      height: 324px
      background: url(http://file.xdf.cn/neworiental/images/yx_indexbg.png) no-repeat -25px -252px
      position: absolute
      top: 0
      left: 0
    li
      width: 100%
      height: 61px
      margin-top: 26px
      a
        .yx_zixunimg
          width: 71px
          height: 60px
          img
            width: 100%
            height: 100%
        .yx_zixunword
          width: 155px
          margin-left: 12px
          margin-top:2px
          p:nth-of-type(1)
            font-size: 14px
            color: #333333
            overflow: hidden
            line-height: 16px
            height: 16px
          p:nth-of-type(2)
            margin-top: 6px
            font-size: 12px
            color: #919191
            line-height: 18px
            height: 32px
            overflow: hidden
        &:hover
          p:nth-of-type(1)
            color: $themeColor
          p:nth-of-type(2)
            color: #9c9c9c
  .yxempty_zixunlist
    i
      display: block
      width: 12px
      height: 410px
      background: url(http://file.xdf.cn/neworiental/images/yx_indexbg.png) no-repeat -558px -65px
</style>



// WEBPACK FOOTER //
// src/pages/primaryschool/components/mainfloor/Zixun.vue